import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

//Why we need HashRouter:    https://stackoverflow.com/questions/66326106/react-router-locations-on-aws-s3-bucket-do-not-work
import { createBrowserHistory } from 'history'

const replaceHashPath = () => {
  const history = createBrowserHistory()
  const hash = history.location.hash
  if (hash) {
    const path = hash.replace(/^#/, '')
    if (path) {
      history.replace(path)
      //console.log(history);
    }
  }
}
//replaceHashPath()

//console.log(window.location);

/**
 * Note: https://stackoverflow.com/questions/71668256/deprecation-notice-reactdom-render-is-no-longer-supported-in-react-18
 */
const root = ReactDOM.createRoot(document.getElementById("root"));
//ReactDOM.render(
root.render(
  //<React.StrictMode>
    <App />
  //</React.StrictMode>
  // ,
  // document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
